import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="no-print mt-16 border-t border-fern/10 bg-white/60 backdrop-blur-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <p className="text-center sm:text-left">
          © {new Date().getFullYear()} NestWise. Made with aroha in Aotearoa.
        </p>
        <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          <Link
            data-testid="footer-pricing-link"
            to="/pricing"
            className="hover:text-fern transition-colors"
          >
            Pricing
          </Link>
          <span className="text-slate-300">·</span>
          <Link
            data-testid="footer-contact-link"
            to="/contact"
            className="hover:text-fern transition-colors"
          >
            Contact
          </Link>
          <span className="text-slate-300">·</span>
          <Link
            data-testid="footer-legal-link"
            to="/legal"
            className="hover:text-fern transition-colors"
          >
            Terms & Disclaimers
          </Link>
          <span className="text-slate-300">·</span>
          <Link
            data-testid="footer-privacy-link"
            to="/legal#privacy"
            className="hover:text-fern transition-colors"
          >
            Privacy
          </Link>
          <span className="text-slate-300">·</span>
          <Link
            data-testid="footer-consumer-link"
            to="/legal#consumer"
            className="hover:text-fern transition-colors"
          >
            Consumer Rights
          </Link>
          <span className="text-slate-300">·</span>
          <span className="text-slate-400">
            Years 5-7 homeschool platform
          </span>
        </nav>
      </div>
    </footer>
  );
}
